import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DropDownForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState('');
  const handleChangeDD = (event) => {
    const question = { ...element, userInput: event.target.value, eligibleErr: true };
    if (question?.isEligibal) {
      const eligVal = question?.eligibleValues?.split(',').map((item) => item?.trim());

      if (eligVal?.includes(question?.userInput?.trim())) {
        question.eligibleErr = false;
      }
    }
    if (element?.isRequired) {
      if (event.target.value === '') {
        question.validationError = true;
      }
    } else {
      question.validationError = false;
    }
    if (question?.isRequired) {
      if (question?.userInput !== '' && question?.userInput !== undefined ) {
        setShowError('');
        question.validationError = false;
      } else {
        setShowError("required");
        question.validationError = true;
      }
    } else {
      setShowError('');
      question.validationError = false;
    }
    handleChange(event, question);
  };

  return (
    <div className="d-flex">
      <div className="w-100">
        <Form.Select
          name={element?.question}
          className="formSelectors fs-13 answer"
          onChange={handleChangeDD}
          value={element?.userInput || element?.placeholder}
        >
          <option value={''}>{element?.placeholder}</option>

          {element?.values?.split(',').map((val, index) => (
            <option key={`${element?._id}-${val}-${index}`} value={val}>
              {val}
            </option>
          ))}
        </Form.Select>
        <span className="text-danger fs-12">{showError !== '' && showError}</span>
      </div>
    </div>
  );
};

DropDownForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  isInputEligible: PropTypes.bool.isRequired,
};
export default DropDownForm;
